import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  CamCmsService,
  CmsComponent,
  LinkComponent,
  RichTextComponent,
  SaleComponent,
  TextComponent,
} from '@camelot/cms';
import { CamTenantService } from '@camelot/server';

import { TestIdDirective } from '@camelot/testing-harness';

interface RichParagraphText {
  bold: boolean;
  italic: boolean;
  text: string;
  type: 'text';
  underline: boolean;
}

interface RichParagraphLink {
  children: RichParagraphText[];
  type: 'link';
  url: string;
}

type RichText = {
  children: (RichParagraphLink | RichParagraphText)[];
  level: 1 | 2 | 3 | 4 | 5 | 6;
  type: 'heading' | 'paragraph';
}[];

const richParagraphText: RichParagraphText = {
  bold: false,
  italic: false,
  text: 'Some cms text',
  type: 'text',
  underline: false,
};

const richParagraphLink: RichParagraphLink = {
  children: [richParagraphText],
  type: 'link',
  url: 'https://example.com',
};

const richText: RichText = [{ children: [richParagraphText, richParagraphLink], level: 1, type: 'paragraph' }];

const cmsServiceMock = {
  cmsContents: { get$: () => of([]) },
  fetchCmsContents$: () => of([]),
};

const tenantServiceMock = {
  currentTenantId$: of(1),
};

@Component({
    imports: [CmsComponent, LinkComponent, RichTextComponent, SaleComponent, TestIdDirective, TextComponent],
    providers: [
        { provide: CamCmsService, useValue: cmsServiceMock },
        { provide: CamTenantService, useValue: tenantServiceMock },
    ],
    template: `
    <cam-cms camTestId="cam-cms" contentType="e2e-content" />
    <cam-sale camTestId="cam-sale" />
    <cam-rich-text camTestId="cam-rich-text" [richText]="this.richText" />
    <cam-rich-paragraph-text camTestId="cam-rich-paragraph-text" [text]="this.text" />
    <cam-rich-paragraph-link camTestId="cam-rich-paragraph-link" [link]="this.link" />
  `
})
export class CmsCase {
  public link = richParagraphLink;
  public richText = richText;
  public text = richParagraphText;
}
